module.exports = __webpack_public_path__ + "img/header.43e2b90c.png";